export const ReferralCodeCookie = 'litfibre-referral';

export const OtsCookie = 'litfibre-ots-id';

export const NewsletterFormCookie = 'litfibre-newsletter-form';

export const PurchaseEventCookie = 'litfibre-purchase';

export const ContactUsFormSubmitted = 'litfibre-contact-us';

export const ContactCookie = 'litfibre-contact-lead';

export const InterestCookie = 'litfibre-address';

export const RegionalPromoCookie = 'litfibre-promo';

export const ProductCookie = 'litfibre-product';

export const BundleCookie = 'litfibre-bundle';

export const ContractLengthCookie = 'litfibre-contract-length';

export const GatsbyGdprCookie = 'gatsby-gdpr-google-analytics';

export const Covid19Cookie = 'litfibre-covid-19';

export const GatsbyGdprTagManagerCookie = 'gatsby-gdpr-google-tagmanager';

export const OrderCookie = 'litfibre-order';

export const CookieFirstConsentCookie = 'cookiefirst-consent';
